import { mobileApiRequest } from '../../apiRequests'

export const getWorkspaceMetadata = async (tableStats, workspaceID, isPolling = false) => {
    const action = {
        action: 'getWorkspaceMetadata',
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }
    if (tableStats) action.tableStats = true
    if (workspaceID) {
        action.workspaceID = workspaceID
    }
    if (isPolling) {
        action.isPolling = true
    }
    return await mobileApiRequest(action)
}

export const saveNewMetric = async (metric) => {
    const action = {
        action: 'putObject',
        class: 'scoop.metric.Metric',
        value: metric,
    }
    return await mobileApiRequest(action)
}

export const deleteMetric = async (metricID) => {
    const action = {
        action: 'deleteObject',
        class: 'scoop.metric.Metric',
        key: metricID,
    }
    return await mobileApiRequest(action)
}

export const addSavedFilter = async (workspaceID, filterName, filter, filterKey) => {
    const action = {
        action: 'putObject',
        class: 'scoop.queryfilter.SavedFilter',
        value: {
            workspaceID,
            filterName,
            filter,
            savedFilterKey: filterKey || null,
        },
    }
    return await mobileApiRequest(action)
}

export const deleteSavedFilter = async (savedFilterKey) => {
    const action = {
        action: 'delete',
        savedFilterKey: savedFilterKey,
    }
    return await mobileApiRequest(action)
}

export const saveNewTheme = async (themeName, canvasID, chartPreferences, colorScheme, fonts) => {
    const getAction = {
        action: 'getNewID',
        class: 'scoop.presentation.Theme',
    }
    const response = await mobileApiRequest(getAction)
    const newThemeID = response.data
    const saveAction = {
        action: 'putObject',
        class: 'scoop.presentation.Theme',
        value: {
            themeID: newThemeID,
            themeName,
            canvasID,
            chartPreferences,
            colorScheme,
            fonts,
        },
    }
    return await mobileApiRequest(saveAction)
}

export const deleteInbox = async (inboxID) => {
    const action = {
        action: 'delete',
        inboxID,
        deleteAll: true,
    }
    return await mobileApiRequest(action)
}

export const validateMetricFormula = async (formula, format) => {
    const action = {
        action: 'validateFormula',
        formula: formula,
        format: format,
    }
    return await mobileApiRequest(action)
}
